type UseCreateStateClient = () => any;

export const useCreateStateClient: UseCreateStateClient = () => {
  return {};
};
